import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from '../ui/Container';
import { Linkedin, Mail, MapPin, Phone } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gradient-primary text-slate-300 py-16 border-t border-white/10" data-id="element-303">
      <Container data-id="element-304">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-305">
          <div className="col-span-1 md:col-span-1" data-id="element-306">
            <div className="flex items-center space-x-2 mb-6" data-id="element-307">
              <div className="h-10 w-10 bg-gradient-accent rounded-lg flex items-center justify-center shadow-lg" data-id="element-308">
                <span className="text-white font-black text-xl" data-id="element-309">L</span>
              </div>
              <span className="text-2xl font-bold tracking-tight text-white" data-id="element-310">
                LAI Solutions
              </span>
            </div>
            <p className="text-sm text-slate-400 leading-relaxed mb-6" data-id="element-311">
              Engineering systems that work. We integrate and automate your
              Microsoft environment to reduce admin and deliver projects on
              time.
            </p>
            <div className="flex space-x-4" data-id="element-312">
              <a href="https://www.linkedin.com/company/lai-solutions" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-brand-orange-400 transition-colors" data-id="element-313">
                <Linkedin size={22} data-id="element-314" />
              </a>
            </div>
          </div>

          <div data-id="element-315">
            <h3 className="text-white font-bold mb-6 text-lg" data-id="element-316">Solutions</h3>
            <ul className="space-y-3 text-sm" data-id="element-317">
              <li data-id="element-318">
                <Link to="#" className="hover:text-brand-orange-400 transition-colors flex items-center group" data-id="element-319">
                  <span className="w-1.5 h-1.5 bg-brand-orange-500 rounded-full mr-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-320"></span>
                  Document Control
                </Link>
              </li>
              <li data-id="element-321">
                <Link to="#" className="hover:text-brand-orange-400 transition-colors flex items-center group" data-id="element-322">
                  <span className="w-1.5 h-1.5 bg-brand-orange-500 rounded-full mr-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-323"></span>
                  Project Reporting
                </Link>
              </li>
              <li data-id="element-324">
                <Link to="#" className="hover:text-brand-orange-400 transition-colors flex items-center group" data-id="element-325">
                  <span className="w-1.5 h-1.5 bg-brand-orange-500 rounded-full mr-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-326"></span>
                  Quality & ITPs
                </Link>
              </li>
              <li data-id="element-327">
                <Link to="#" className="hover:text-brand-orange-400 transition-colors flex items-center group" data-id="element-328">
                  <span className="w-1.5 h-1.5 bg-brand-orange-500 rounded-full mr-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-329"></span>
                  Procurement
                </Link>
              </li>
              <li data-id="element-330">
                <Link to="#" className="hover:text-brand-orange-400 transition-colors flex items-center group" data-id="element-331">
                  <span className="w-1.5 h-1.5 bg-brand-orange-500 rounded-full mr-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-332"></span>
                  Timesheets & Variations
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-333">
            <h3 className="text-white font-bold mb-6 text-lg" data-id="element-334">Company</h3>
            <ul className="space-y-3 text-sm" data-id="element-335">
              <li data-id="element-336">
                <Link to="/about" className="hover:text-brand-orange-400 transition-colors flex items-center group" data-id="element-337">
                  <span className="w-1.5 h-1.5 bg-brand-orange-500 rounded-full mr-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-338"></span>
                  About Us
                </Link>
              </li>
              <li data-id="element-339">
                <Link to="/case-studies" className="hover:text-brand-orange-400 transition-colors flex items-center group" data-id="element-340">
                  <span className="w-1.5 h-1.5 bg-brand-orange-500 rounded-full mr-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-341"></span>
                  Case Studies
                </Link>
              </li>
              <li data-id="element-342">
                <Link to="/resources" className="hover:text-brand-orange-400 transition-colors flex items-center group" data-id="element-343">
                  <span className="w-1.5 h-1.5 bg-brand-orange-500 rounded-full mr-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-344"></span>
                  Resources
                </Link>
              </li>
              <li data-id="element-345">
                <Link to="/contact" className="hover:text-brand-orange-400 transition-colors flex items-center group" data-id="element-346">
                  <span className="w-1.5 h-1.5 bg-brand-orange-500 rounded-full mr-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-347"></span>
                  Contact
                </Link>
              </li>
              <li data-id="element-348">
                <Link to="/privacy" className="hover:text-brand-orange-400 transition-colors flex items-center group" data-id="element-349">
                  <span className="w-1.5 h-1.5 bg-brand-orange-500 rounded-full mr-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-350"></span>
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-351">
            <h3 className="text-white font-bold mb-6 text-lg" data-id="element-352">Contact</h3>
            <ul className="space-y-4 text-sm" data-id="element-353">
              <li className="flex items-start space-x-3" data-id="element-354">
                <MapPin size={18} className="mt-0.5 shrink-0 text-brand-orange-400" data-id="element-355" />
                <span data-id="element-356">
                  Perth, Western Australia
                  <br data-id="element-357" />
                  Serving Australia-wide
                </span>
              </li>
              <li className="flex items-center space-x-3" data-id="element-358">
                <Mail size={18} className="shrink-0 text-brand-orange-400" data-id="element-359" />
                <a href="mailto:hello@laisolutions.com.au" className="hover:text-brand-orange-400 transition-colors" data-id="element-360">
                  hello@laisolutions.com.au
                </a>
              </li>
              <li className="flex items-center space-x-3" data-id="element-361">
                <Phone size={18} className="shrink-0 text-brand-orange-400" data-id="element-362" />
                <a href="tel:+61892266399" className="hover:text-brand-orange-400 transition-colors" data-id="element-363">
                  +61 8 9226 6399
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center text-sm text-slate-500" data-id="element-364">
          <p data-id="element-365">
            &copy; {new Date().getFullYear()} LAI Solutions. All rights
            reserved.
          </p>
          <p className="mt-2 md:mt-0 text-brand-orange-400 font-semibold" data-id="element-366">
            Engineering First. AI Second.
          </p>
        </div>
      </Container>
    </footer>;
}